const Articolo = () => import("./Articolo")
const CostiArticolo = () => import("./CostiArticolo")
import store from "../../store"
import { ensureCapabilities } from "../../utils/accessControl.mjs"

const ifCapability = (key, fallbackGroups = []) => async (to, from, next) => {
    if (!store.getters.isLoggedIn) return next('/login')
    try {
        await ensureCapabilities(store, window.work_api)
        return store.getters.hasCapability(key) ? next() : next('/')
    } catch (error) {
        if (fallbackGroups.length === 0 || store.getters.hasGroups(fallbackGroups)) return next()
        return next('/')
    }
}

export default [
    {
        path: '/articoli/rischio-margine',
        name: 'ArticoliRischioMargine',
        meta: { menu: 'articolo', title: 'Articoli a rischio margine' },
        component: () => import('./ArticoliRischioMargine.vue'),
        beforeEnter: (to, from, next) => next(store.getters.isLoggedIn ? undefined : '/login'),
    },
    {
        path: '/articoli/:codice?/costi',
        name: 'CostiArticolo',
        meta: {
            menu: 'articolo',
            title: 'Scheda costi',
            apiAccessFeedback: true,
            access: {
                key: 'articles.costs.view',
                defaultGroups: ['Amministrazione'],
                description: 'Pagina e API con il dettaglio dei costi articolo.',
            },
        },
        component: CostiArticolo,
        // The page renders the authenticated API's 403 or service error in place.
        beforeEnter: (to, from, next) => next(store.getters.isLoggedIn ? undefined : '/login'),
    },
    {
        path: '/articoli/:codice',
        name: 'Articolo',
        meta: {
            menu: 'articolo',
            title: 'Articolo',
            access: {
                key: 'articles.detail',
                description: 'Accesso alla scheda articolo di base.',
            },
            accessModules: [
                {
                    key: 'articles.quotations.view',
                    name: 'Listini e quotazioni',
                    description: 'Visualizzazione e modifica dei listini e dei valori di quotazione collegati.',
                    defaultGroups: ['Amministrazione'],
                },
            ],
        },
        component: Articolo,
        beforeEnter: ifCapability('articles.detail'),

    },
]
